import { apiRequest } from "../utils/useAPIRequest";
import { businessStore, splitpaymentStore } from "../stores";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
// import moment from "moment";
import constant from "../utils/constant";

const useGetSplitPayments = (
  splitPaymentTableQuery,
  filterQuery,
  searchQuery
) => {
  const id = businessStore.bId;

  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${splitPaymentTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${splitPaymentTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${splitPaymentTableQuery}&${filterQuery}`;
    } else {
      return splitPaymentTableQuery;
    }
  }, [filterQuery, splitPaymentTableQuery, searchQuery]);

  return useQuery({
    queryKey: [id, "getSplitpaymentTransactions", query],
    queryFn: () => {
      return apiRequest({
        url: `/transactions/split/admin?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const splitAnalysis = async (query) => {
  if (!query) {
    // const startDate = moment("2022-01-01");
    // const endDate = moment().endOf("month");
    // query = `startDate=${startDate}&endDate=${endDate}&business=62a86480a2160f7962344ac7`;
    query = ""
  }
  const { status, data, errorMessage } = await apiRequest({
    url: `/transactions/admin/split-analysis?${query}`,
    method: "get",
  });

  if (status === constant.Success) {
    splitpaymentStore.setSplitAnalysis(data);
    return { status: constant.Success };
  }
  return { errorMessage, status };
};

const SplitPaymentsController = {
  useGetSplitPayments,
  splitAnalysis,
};

export default SplitPaymentsController;
